export default "__VITE_ASSET__Pqh7GxUO__"